/** Official Tyaus company logo — same source path as Tyaus Main Website. */
export const COMPANY_LOGO_PATH = '/Logo/TY.png';
export const COMPANY_NAME = 'Tyaus';
